import { render } from "./IndexView.vue?vue&type=template&id=1e2660be&scoped=true&ts=true"
import script from "./IndexView.vue?vue&type=script&lang=ts"
export * from "./IndexView.vue?vue&type=script&lang=ts"

import "./IndexView.vue?vue&type=style&index=0&id=1e2660be&scoped=true&lang=css"

import exportComponent from "/OfficialWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2660be"]])

export default __exports__